import axios from "axios";

class ExportToPdf {
  async CallFuncToExport(HTML) {
    try {
      const FUNC = await axios.post(
        `https://func-pdfcreator.azurewebsites.net/api/PdfCreator`,
        HTML,
        {
          headers: { "Content-Type": "text/html" },
          responseType: "arraybuffer"
        }
      );
      return FUNC.data;
    } catch (err) {
      console.log(err);
    }
  }
}

export default new ExportToPdf();
